class App {
  constructor() {
    this.preDefinedApps = {
      YOUTUBE: "YouTube",
      USB: "Media",
      CHROMECAST: "GoogleCast"
    }
  }
  _init = async () => {
    return true
  }

  getList = async () => {
    let promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.APPS}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.APPS,
      CmdType: "Request",
      Fun: "ApplicationControl",
      CommandDetails: {
        RequestListOfAvailableApplications: {
          Filter: ["Native", "NonNative"]
        }
      }
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return _$.error(payload.detail)
    else
      return payload.detail.CurrentAvailableApplicationList.map(app => {
        return { key: app.ApplicationName, value: app.ApplicationName }
      })
  }
  launch = async app_id => {
    let requestObject_ = {
      Cookie: __._api.cookies.APP,
      CmdType: "Change",
      Fun: "ApplicationControl",
      CommandDetails: {
        ApplicationDetails: {
          ApplicationName: app_id
        },
        ApplicationState: "Activate"
      }
    }
    __._api._sendCommand(requestObject_)
    return true
  }
  close = async (app_id = null) => {
    let activeApplications = []
    if (app_id) activeApplications.push(app_id)
    else {
      const apps = await this._getCurrentApps()
      if (apps && apps.length) activeApplications.push(...apps)
    }

    for (const app of activeApplications) {
      const requestObject_ = {
        Cookie: __._api.cookies.APP,
        CmdType: "Change",
        Fun: "ApplicationControl",
        CommandDetails: {
          ApplicationDetails: {
            ApplicationName: app
          },
          ApplicationState: "Deactivate"
        }
      }
      __._api._sendCommand(requestObject_)
    }

    return true
  }
  async _getCurrentApps() {
    let promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.APPS}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.APPS,
      CmdType: "Request",
      Fun: "ApplicationControl"
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return _$.error(payload.detail)
    const apps = payload.detail.ActiveApplications.filter(rec => !["VolumeControl", "CustomDashboard"].includes(rec?.ApplicationName)).map(
      rec => rec.ApplicationName
    )
    return apps
  }
}

export default App
